import { addDays, isAfter, isValid, parseISO } from "date-fns";

export const isAppArchived = (createdAt) => {
  if (createdAt == null) return false;
  const created = createdAt instanceof Date ? createdAt : parseISO(createdAt);
  if (!isValid(created)) return false;
  return isAfter(new Date(), addDays(created, 30));
};
